import i18n from '@/locales'
export const BAND_WIDTH_OPTION = [
  { label: i18n.t('network.bandwidth_option.100m'), value: '100' },
  { label: i18n.t('network.bandwidth_option.1g'), value: '1000' },
  { label: i18n.t('network.bandwidth_option.2x1g'), value: '2000' },
  { label: i18n.t('network.bandwidth_option.10g'), value: '10000' },
  { label: i18n.t('network.bandwidth_option.2x10g'), value: '20000' },
  { label: i18n.t('network.bandwidth_option.25g'), value: '25000' },
  { label: i18n.t('network.bandwidth_option.2x25g'), value: '50000' },
  { label: i18n.t('network.bandwidth_option.40g'), value: '40000' },
  { label: i18n.t('network.bandwidth_option.2x40g'), value: '80000' },
  { label: i18n.t('network.bandwidth_option.100g'), value: '100000' },
  { label: i18n.t('network.bandwidth_option.2x100g'), value: '200000' },
  { label: i18n.t('network.bandwidth_option.200g'), value: '200000' },
  { label: i18n.t('network.bandwidth_option.2x200g'), value: '400000' },
  { label: i18n.t('network.bandwidth_option.400g'), value: '400000' },
  { label: i18n.t('network.bandwidth_option.2x400g'), value: '800000' },
  { label: i18n.t('network.bandwidth_option.800g'), value: '800000' },
  { label: i18n.t('network.bandwidth_option.2x800g'), value: '1600000' },
]
